<ngx-spinner
    bdColor="rgba(0, 0, 0, 0.5)"
    size="medium"
    color="#fff"
    type="ball-scale-multiple">
    <p class="mt-4 text-lg text-white">Please wait...</p>
</ngx-spinner>

<div class="absolute inset-0 flex flex-col flex-auto min-w-0 overflow-y-auto bg-gray-50 dark:bg-gray-900">

    <div
        class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:p-8 border-b bg-card dark:bg-black dark:bg-opacity-5">
        <div class="text-4xl font-extrabold tracking-tight">Marketing Banners</div>

        <div class="flex flex-col sm:flex-row shrink-0 sm:items-center gap-4 mt-6 sm:mt-0 sm:ml-4" [formGroup]="bannerForm">

            <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full sm:w-48">
                <mat-label>Language</mat-label>
                <mat-select formControlName="language">
                    <mat-option *ngFor="let lang of defaultLanguages" [value]="lang.code">
                        <span>{{ lang.label }}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <button mat-flat-button type="button" (click)="saveBanners()" color="primary"
                    [disabled]="isLoading">
                <mat-icon class="mr-2" *ngIf="!isLoading"
                          svgIcon="heroicons_outline:check"></mat-icon>
                <span>Save All Changes</span>
            </button>
        </div>
    </div>

    <div class="flex-auto p-6 sm:p-8">
        <div class="w-full max-w-screen-xl mx-auto">
            <form [formGroup]="bannerForm" (ngSubmit)="saveBanners()">
                <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-8">

                    <div class="lg:col-span-2 flex flex-col gap-8">
                        <fuse-card class="w-full p-6 sm:p-8 rounded-2xl">
                            <div class="w-full">
                                <h2 class="text-xl font-semibold">YouTube Video</h2>
                                <p class="text-secondary">The main promotional video for this language.</p>

                                <div class="flex items-center gap-4 mt-6">

                                    <div class="flex-1">
                                        <mat-form-field class="w-full">
                                            <mat-label>YouTube URL</mat-label>
                                            <input matInput formControlName="youtubeUrl" (change)="setPreview('youtube')"
                                                   placeholder="e.g., https://www.youtube.com/watch?v=...">
                                        </mat-form-field>
                                    </div>
                                    <button mat-stroked-button type="button" (click)="setPreview('youtube')"
                                            class="flex-shrink-0">
                                        <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
                                        <span class="ml-2 hidden sm:inline">Preview</span>
                                    </button>

                                </div>
                            </div>
                        </fuse-card>

                        <fuse-card class="w-full p-6 sm:p-8 rounded-2xl">
                            <div class="flex items-center justify-between w-full">
                                <div class="w-full">
                                    <h2 class="text-xl font-semibold">Image Banners</h2>
                                    <p class="text-secondary">Drag to reorder. Click to preview.</p>

                                    <!-- The list of banners -->
                                    <div cdkDropList
                                         formArrayName="images"
                                         class="mt-6 space-y-4"
                                         [cdkDropListData]="bannerImages.controls"
                                         (cdkDropListDropped)="drop($event)">
                                        <div *ngFor="let imageControl of bannerImages.controls; let i = index"
                                             cdkDrag
                                             [formGroupName]="i"
                                             class="flex items-center gap-4 p-3 rounded-lg border bg-gray-50 dark:bg-gray-800">

                                            <div cdkDragHandle
                                                 class="banner-drag-handle text-gray-400 dark:text-gray-500 cursor-move">
                                                <mat-icon svgIcon="heroicons_solid:bars-3"></mat-icon>
                                            </div>

                                            <div
                                                class="flex-shrink-0 w-32 h-16 rounded-md bg-gray-100 dark:bg-gray-900/50 flex items-center justify-center overflow-hidden relative cursor-pointer group"
                                                (click)="setPreview('image', i)"
                                                [ngClass]="{'ring-2 ring-primary-500': activePreview?.type === 'image' && activePreview?.url === imageControl.get('previewUrl').value}">
                                                <ng-container
                                                    *ngIf="imageControl.get('previewUrl').value as previewUrl">
                                                    <img [src]="previewUrl" alt="Banner Preview"
                                                         class="object-cover w-full h-full">
                                                </ng-container>
                                                <ng-container *ngIf="!imageControl.get('previewUrl').value">
                                                    <mat-icon class="icon-size-8 text-secondary"
                                                              svgIcon="heroicons_outline:photo"></mat-icon>
                                                </ng-container>
                                                <div
                                                    class="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity">
                                                    <label class="w-full h-full flex items-center justify-center text-white font-semibold text-sm cursor-pointer">
                                                        <input #fileInput type="file" class="hidden"
                                                               (change)="onFileSelected($event, i)"
                                                               accept="image/png, image/jpeg, image/webp, image/gif">
                                                        <span>{{ imageControl.get('previewUrl').value ? 'Change' : 'Upload' }}</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <mat-form-field class="flex-auto fuse-mat-dense fuse-mat-no-subscript">
                                                <mat-label>Target URL (optional)</mat-label>
                                                <input matInput formControlName="targetUrl"
                                                       placeholder="https://example.com/page">
                                            </mat-form-field>

                                            <button mat-icon-button type="button" (click)="setPreview('image', i)"
                                                    matTooltip="Preview this banner">
                                                <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
                                            </button>
                                            <button mat-icon-button type="button" color="warn" (click)="removeImage(i)"
                                                    matTooltip="Remove banner">
                                                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                            </button>
                                        </div>
                                        <div *cdkDragPlaceholder class="h-24 rounded-lg"></div>
                                    </div>

                                    <div class="flex justify-end mt-6">
                                        <button mat-stroked-button type="button" (click)="addBanner()">
                                            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                                            <span class="ml-2">Add Banner</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </fuse-card>
                    </div>

                    <div class="hidden lg:block lg:col-span-1">
                        <div class="sticky top-8">
                            <fuse-card class="w-full rounded-2xl overflow-hidden">
                                <div class="flex flex-col h-full w-full">

                                    <div class="p-6">
                                        <h3 class="text-lg font-semibold">Live Preview</h3>
                                    </div>
                                    <div class="aspect-w-16 aspect-h-9 bg-black">
                                        <div class="w-full h-full flex items-center justify-center">

                                            <ng-container *ngIf="activePreview; else noPreview">
                                                <ng-container [ngSwitch]="activePreview.type">
                                                    <iframe *ngSwitchCase="'youtube'"
                                                            [src]="safeYoutubeUrl"
                                                            allowfullscreen
                                                            class="w-full h-full"></iframe>
                                                    <img *ngSwitchCase="'image'"
                                                         [src]="activePreview.url"
                                                         alt="Banner Preview"
                                                         class="object-contain w-full h-full">
                                                </ng-container>
                                            </ng-container>
                                            <ng-template #noPreview>
                                                <div class="flex flex-col items-center text-secondary p-4">
                                                    <mat-icon class="icon-size-12"
                                                              svgIcon="heroicons_outline:video-camera"></mat-icon>
                                                    <p class="mt-2 font-medium">Preview will appear here</p>
                                                </div>
                                            </ng-template>

                                        </div>
                                    </div>
                                </div>
                            </fuse-card>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
